export default {
  wmsUrl: process.env.REACT_APP_API_WMS_URL,
  token: process.env.REACT_APP_API_WMS_TOKEN,
};
